import React from 'react';
import './App.css';
import "react-toastify/dist/ReactToastify.css";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import SearchAddressWrapper from "./pages/SignUp/SearchAddress/SearchAddressWrapper";
import {SignupProvider} from "./context/SignupContext";
import SummaryWrapper from "./pages/SignUp/Summary/SummaryWrapper";
import ContactDetailsWrapper from "./pages/SignUp/ContactDetails/ContactDetailsWrapper";
import CompletedWrapper from "./pages/SignUp/Completed/CompletedWrapper";
import {ToastContainer} from "react-toastify";

const App: React.FC = () => {
  return (
      <SignupProvider>
        <Router>
          <Routes>
            <Route path="/" element={<SearchAddressWrapper />} />
            <Route path="/address-select" element={<SearchAddressWrapper />} />
            <Route path="/contact-details" element={<ContactDetailsWrapper />} />
            <Route path="/summary" element={<SummaryWrapper />} />
            <Route path="/completed" element={<CompletedWrapper />} />
          </Routes>
        </Router>
        <ToastContainer />
      </SignupProvider>
  );
}

export default App;
